import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import Modal from 'components/Modal';
import {Set} from 'immutable';
import {default as TypefaceSubsetting, SUBSETTING_BASIC} from './TypefaceSubsetting';

export default createReactClass({
  propTypes: {
    show: PropTypes.bool.isRequired,
    typefaceSettings: ImmutablePropTypes.record,
    characterSets: ImmutablePropTypes.list,
    onClosed: PropTypes.func.isRequired,
    onSaved: PropTypes.func.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  getInitialState() {
    return this.getState(this.props);
  },

  componentWillReceiveProps(props) {
    this.setState(this.getState(props));
  },

  getState(props) {
    const {
      typefaceSettings,
    } = props;

    return {
      subsetting: (typefaceSettings) ? typefaceSettings.defaultSubsetting : SUBSETTING_BASIC,
      characterSets: (typefaceSettings) ? Set(typefaceSettings.characterSets) : Set(),
    };
  },

  handleSubsettingChanged(subsetting) {
    this.setState({subsetting});
  },

  handleCharacterSetChanged(id, isChecked) {
    const {characterSets} = this.state;

    this.setState({
      characterSets: (isChecked) ? characterSets.add(id) : characterSets.delete(id),
    });
  },

  handleClosed(event) {
    if (event) {
      event.preventDefault();
    }

    this.props.onClosed();
  },

  handleSaved(event) {
    const nextTypefaceSettings = this.props.typefaceSettings
      .set('defaultSubsetting', this.state.subsetting)
      .set('characterSets', this.state.characterSets);

    this.props.onSaved(nextTypefaceSettings);
  },

  renderModalBody() {
    const {
      subsetting,
      characterSets: selectedCharacterSetIds,
    } = this.state;
    const {
      characterSets,
    } = this.props;

    return (
      <div className="modal-body">
        <form className="simple_form form-horizontal">
          <div className="form-group row required">
            <label className="required col-xs-4 form-control-label p-xs-r-sm">
              Character Subsetting <span title="Required">*</span>
            </label>
            <div className="col-xs-8">
              <TypefaceSubsetting
                subsetting={subsetting}
                selectedCharacterSetIds={selectedCharacterSetIds}
                characterSets={characterSets}
                onSubsettingChanged={this.handleSubsettingChanged}
                onCharacterSetChanged={this.handleCharacterSetChanged}
              />
            </div>
          </div>
        </form>

        <hr />

        <p className="text-muted m-xs-b-0">When adding a typeface to your kit, these options will be selected by default.</p>
      </div>
    );
  },

  render() {
    return (
      <Modal contentLabel="Typeface settings" isOpen={this.props.show} onRequestClose={this.handleClosed}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header bg-body dashed dashed-bottom m-xs-b-xs p-xs-b-sm">
              <button onClick={this.handleClosed} type="button" className="close close-dangle">
                <span aria-hidden="true"><i className="ficon ficon-times"></i></span>
              </button>
              <h3 className="modal-title">
                <i className="ficon ficon-gear text-gray-lighter m-xs-r-xs"></i> Typeface Settings
              </h3>
            </div>
            {this.renderModalBody()}
            <div className="modal-footer bg-body">
              <button onClick={this.handleClosed} type="button" className="btn btn-link">Cancel</button>
              <button onClick={this.handleSaved} type="submit" className="btn btn-primary">
                Save Typeface Settings <i className="ficon ficon-check-circle p-xs-l-xs"></i>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/TypefacesSettings.js